import * as angular from 'angular';
import {IController} from "angular";

export class ImportRecurringServicesTableRowCtrl implements IController {
  service: any;
  isSelected: any;
  isExpended: any;
  toggle: Function;
  onEdit: Function;
  onRemove: Function;


  /* @ngInject */
  constructor() {
  }

  $onInit() {

  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  checkBoxClick() {
    this.toggle({serviceId: this.service.id});
  }

  onBeforeExpand() {
    // const hasRelations = _.some(this.service.taskList, (t) => {
    //   return t.relations && t.relations.length;
    // });
    // if (hasRelations) {
    //   this.onExpand({serviceId: this.id});
    // }
  }

}

angular
  .module('bringoz.admin.deliveries')
  .component('importRecurringServicesTableRow', {
    bindings: {
      service: '<',
      isSelected: '<',
      isExpended: '<',
      toggle: '&',
      onEdit: '&',
      onRemove: '&'
    },
    template: require('./import-recurring-services-table-row.html').default,
    controller: ImportRecurringServicesTableRowCtrl
  });
